import { createStore } from 'vuex';
import mqtt from 'mqtt';

export const mainStore = createStore({
    state() {
        return {
            data: {},
            historyForDiagram: {},
        }
    },
    mutations: {
        update(state, { topic, message }) {
            const _message = parseFloat(message);
            state.data[topic] = parseFloat(_message);


            if (!state.historyForDiagram[topic]) {
                state.historyForDiagram[topic] = [{
                    x: new Date().getTime(),
                    y: _message
                }];
            } else {
                state.historyForDiagram[topic].push({
                    x: new Date().getTime(),
                    y: _message
                });
            
                if (state.historyForDiagram[topic].length > 32) {
                    state.historyForDiagram[topic].shift();
                }
            }
            

            console.log(state.historyForDiagram[topic])
        }
    },
    getters: {
        main: (state) => (topic) => {
            return state.data[topic] ?? 0;
        },
        historyForDiagram: (state) => (topic) => {
            return state.historyForDiagram[topic] ?? [];
        }
    }
})

export function setupMqtt(){
    const mqtt_url = process.env.VUE_APP_MQTT_URL;
    const mqtt_pw = process.env.VUE_APP_MQTT_PW;
    const client = mqtt.connect(mqtt_url, {
        clientId: '',
        username: 'ART_Telemetry',
        password: mqtt_pw,
    });
    
    client.on('connect', () => {
        console.log('MQTT connected');
        try {
            client.subscribe('#', { qos: 0 });
            console.log('Subscribed succesfully');
            
        } catch (error) {
            console.log('subscribing error');
        }
    });

    client.on('message', (topic, message) => {
        console.log('Message to '+topic+': '+message.toString());
        mainStore.commit('update', { topic, message });
    });

    client.on('error', (error) => {
        console.error('Error in MQTT connection:', error);
    });

    client.on('close', () => {
        console.log('MQTT connection is closed');
    });

    client.on('offline', () => {
        console.log('MQTT client is offline');
    });
}